module.exports = __webpack_public_path__ + "static/media/evento-anime-pocket-ingresso-personalizado-768x591.c5bdd02a.jpg";